export default "__VITE_ASSET__DcbgzgV7__";